import { Injectable } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class FormValidationCheckerService {
    isRequired(control: FormControl) {
        const validator = control.validator;
        if (validator) {
            const ctrl = validator({} as AbstractControl);

            return ctrl && ctrl['required'];
        }

        return false;
    }
}
